export const NEW_CHAT_ID = "new-chat";

export const CHAT_ROLES = {
  USER: "user",
  AI: "ai"
};

export const USER_MESSAGE_CHARACTER_LIMIT = 1000;

export const MAX_USER_MESSAGES_TO_SEND_TO_SERVER = 1;
export const DEFAULT_RECENT_CONVERSATIONS = 5;
export const MAX_RECENT_CONVERSATIONS = 200;

export const MESSAGE_ACTIONS = {
  LIKE: "like",
  DISLIKE: "dislike",
  COPY: "copy"
};

export const PENDO_EVENTS = {
  /**
   * Fired when a user first interacts with the chatbot
   */
  CHATBOT_INITIALIZED: "chatbot_initialized",

  /**
   * Fired when a user selects an option from a menu or question examples
   */
  INTRO_PANEL_OPTION_SELECTED: "intro_panel_option_selected",

  /**
   * Fired when a user clicks on "Ask a new question"
   */
  INTRO_PANEL_NEWQ: "intro_panel_newq",

  /**
   * Fired when a user submits their very first question in a session (or ever, if you can track new users).
   */
  FIRST_QUESTION_SUBMITTED: "first_question_submitted",

  /**
   * Fired when a user submits a question to the chatbot.
   */
  QUESTION_SUBMITTED: "question_submitted",

  /**
   * Fired when the chatbot displays an answer to the user.
   */
  ANSWER_DISPLAYED: "answer_displayed",

  /**
   * Fired when a user views their list of recent or past chat sessions.
   */
  RECENT_CHATS_LOAD_MORE: "recent_chats_load_more",

  /**
   * Fired when a user clicks on and reopens a previous chat session.
   */
  RECENT_CHAT_SELECTED: "recent_chat_selected",

  /**
   * Fired when a user provides feedback (e.g., thumbs up/down) on an answer.
   */
  ANSWER_RATED: "answer_rated",

  /**
   * Fired when the user submitts the feddback on negative rating
   */
  FEEDBACK_PROVIDED: "feedback_provided",

  /**
   * Fired when the user presses the copy icon
   */
  COPIED_ANSWER: "copied_answer",

  /**
   * Fired when the user see an error message
   */
  TEAMMATE_AI_ERROR_MESSAGE: "teammate_ai_error_message",

  /**
   * Fired when the user closes the feedback form
   */
  FEEDBACK_RESPONSE_PROVIDED: "feedback_response_provided"
};
